import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace DepartmentApi {
    /**
    * 获取部门列表
    */
    export var GetDepartmentList = (query: any): Promise<any> => {
        return Get(`/msls/DepartmentApi/departmentList?${qs.stringify(query)}`, {});
    };
    /**
     * 新增部门信息
     */
    export var AddDepartment = (body: any): Promise<any> => {
        return Post(`/msls/DepartmentApi/createDepartment`, body);
    };
    /**
     * 修改部门信息
     */
    export var EditDepartment = (id: any, body: any): Promise<any> => {
        return Put(`/msls/DepartmentApi/saveDepartment/${id}`, body);
    };

    /**
     * 删除部门信息
     */
    export var DelDepartment = (id: string): Promise<any> => {
        return Delete(`/msls/DepartmentApi/deleteDepartment/${id}`, {});
    };
    /**
     * 获取部门详情
     */
    export var GetDepartmentDetail = (id: any): Promise<any> => {
        return Get(`/msls/DepartmentApi/departmentDetail/${id}`, {});
    };
    /**
     * 获取用户详情
     */
    export var GetUserDetail = (id: any): Promise<any> => {
        return Get(`/msls/UserApi/userDetail/${id}`, {});
    };


}
